export default function ListDownloadIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      className="ms-1"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 18}
      height={height ? height : width ? width : 18}
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M11.25 17.25a6 6 0 1 0 12 0 6 6 0 1 0-12 0M17.25 14.25v6M17.25 20.25 15 18M17.25 20.25 19.5 18M3.75 6.75h10.5M3.75 11.25h6M3.75 15.75H7.5"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M7.5 20.25H2.25a1.5 1.5 0 0 1-1.5-1.5V2.25a1.5 1.5 0 0 1 1.5-1.5h10.629a1.5 1.5 0 0 1 1.06.439l2.872 2.872a1.5 1.5 0 0 1 .439 1.06V7.5"
      />
    </svg>
  );
}
